// extracted by mini-css-extract-plugin
module.exports = {"input":"checkbox_input__E9KhT"};